/**
 * helper for setting a search box
 */
const setSearchBox = async function({ map, maps, el }) {
    if (map && maps && el) {
        const placeAutocomplete = await new maps.places.PlaceAutocompleteElement();
        placeAutocomplete.className = 'gmp-place-autocomplete';
        el.appendChild(placeAutocomplete);

        map.controls[maps.ControlPosition.TOP_RIGHT].push(el);

        const marker = new maps.Marker();

        placeAutocomplete.addEventListener('gmp-select', async ({ placePrediction }) => {
            const place = placePrediction.toPlace();
            // Clear out the old markers.
            marker.setMap(null);

            await place.fetchFields({
                fields: [
                    'location',
                    'displayName',
                    'id',
                ]
            });

            if (!place.location) {
                console.log('Returned place contains no geometry');
                return;
            }

            marker.setOptions({
                map,
                title: place.displayName,
                position: place.location,
            });

            map.panTo(place.location);
            map.setZoom(15);

        });

    }
};

export default setSearchBox;
